import React, { Component } from 'react';

import Dialog from '../dialog';
import EventView from './eventView';

import CognitoUtil from '../../../../aws/cognito/cognitoUtil';

import moment from 'moment';

export default class EventHistoryModal extends Component {

    constructor() {
    
        super();

        this.localState = {};

    }

    loadMoreData = () => 
    {

        if(this.props.raven.oldest_event)
        {

            this.props.dataStore.getRavenEvents(this.props.raven, this.props.raven.oldest_event);
        }
        else
        {
            var mindate = moment(this.props.raven.events[0].ts).unix();
            var maxdate = moment(this.props.raven.events[this.props.raven.events.length-1].ts).unix();

            this.props.dataStore.getRavenEvents(this.props.raven, mindate < maxdate ? mindate : maxdate);
        }
    }

    queryEventData()
    {
        this.props.dataStore.getRavenEvents(this.props.raven);

    }

    componentDidMount() {
        // Set the initial raven id
        this.localState.ravenid = this.props.raven.item.Id;

        this.queryEventData();
    }

    componentDidUpdate() {

        if(this.props.raven && this.props.raven.item && this.props.raven.item.Id)
        {
            if(this.props.raven.item.Id !== this.localState.ravenid)
            {
                this.localState.ravenid = this.props.raven.item.Id;

                this.queryEventData();
            }
        }
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.props.raven.events ?
                                        this.props.raven.events.length !== 0 ?  
                                            <EventView 
                                                data={this.props.raven.events} 
                                                loading={false}
                                                requestMoreData={this.loadMoreData}
                                                /> : 
                                            <p>No Event Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    
                    </div>
            </Dialog>
        );
    }

}
